<div class="receivables-balance-history-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-balance-history-list-filters">



    <mat-form-field class="receivables-balance-history-list-filter"
    ><mat-label>Kwota od</mat-label>
      <input matInput placeholder="Kwota od" name="gte$sum" [(ngModel)]="initialFilters.gte$sum">
    </mat-form-field>

    <mat-form-field class="receivables-balance-history-list-filter">
      <mat-label>Kwota do</mat-label>
      <input matInput placeholder="Kwota do" name="lte$sum" [(ngModel)]="initialFilters.lte$sum">
    </mat-form-field>

    <mat-form-field class="receivables-balance-history-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="contains$description" [(ngModel)]="initialFilters.contains$description">
    </mat-form-field>

    <mat-form-field class="receivables-balance-history-list-filter">
      <mat-label>TU</mat-label>
      <input matInput placeholder="TU" name="contains$insuranceCompany" [(ngModel)]="initialFilters.contains$insuranceCompany">
    </mat-form-field>

    <app-datepicker
      class="receivables-balance-history-list-filter"
      label="Data od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="receivables-balance-history-list-filter"
      label="Data do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>




  </form>

  <div  class="receivables-balance-history-list-buttons">
        <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()">  <mat-icon>download</mat-icon> Pobierz raport</button>
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="receivablesBalanceHistory" >



    <!-- Position Column -->
    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef> Kwota </th>
      <td mat-cell *matCellDef="let element">
        {{(element.sum !== null ? element.sum : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="detail">
      <th mat-header-cell *matHeaderCellDef> Szczegóły  </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany ? element.insuranceCompany  + '  ' + element.description: element.description}}
      </td>
    </ng-container>


    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data  </th>
      <td mat-cell *matCellDef="let element">
        {{element?.createdAt | date:'y-MM-dd '}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
